import React from 'react';
import { motion } from 'framer-motion';
import { tomos, bonos } from '../data/modules';
export function ModulesGrid() {
  return <section className="py-20 bg-navy-900" data-id="element-154" data-mp="1ms84mgwb6pfx">
      <div className="container mx-auto px-4" data-id="element-155" data-mp="1qt9ui74c5p58">
        <div className="text-center mb-16" data-id="element-156" data-mp="1qsialtk3pfus">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-navy-800/80 text-silver-light border border-silver/30 font-bold mb-6 text-[16px]" data-id="element-157" data-mp="1vsczxso89xdq">
            🔍 LOS 6 TOMOS
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-158" data-mp="25qansf26ds5t">
            Un tomo por cada dimensión de la Criminalística Argentina
          </h2>
          <p className="text-silver font-medium text-[16px]" data-id="element-159" data-mp="2ai2csl5onptu">
            Contenido 100% argentino, actualizado al 2026 y listo para el aula.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-160" data-mp="2jja1qcmb7eb9">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i % 2 * 0.1
        }} className="rounded-2xl border border-silver/20 bg-navy-950/80 overflow-hidden shadow-lg flex flex-col h-full relative" data-id="element-161" data-mp="2ohbn5477jppw" data-mpi={i}>
              {tomo.badge && <div className="absolute top-0 right-0 bg-silver text-navy-950 font-bold text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-162" data-mp="1g0swim5no0tk">
                  {tomo.badge}
                </div>}
              <div className="bg-navy-800/70 p-4 border-b border-silver/20 flex items-center gap-3" data-id="element-163" data-mp="166sn483cc9f1">
                <div className="text-3xl" aria-hidden="true" data-id="element-164" data-mp="23qdjrh8udk8n">
                  {tomo.emoji}
                </div>
                <div data-id="element-165" data-mp="2htsybdhgm1vg">
                  <p className="text-xs font-bold uppercase tracking-wider text-silver" data-id="element-166" data-mp="2htaw80848tfm">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-167" data-mp="2ms48jpbo2ee7">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-168" data-mp="2d219b7dyc47f">
                <p className="text-silver text-sm leading-relaxed mb-4" data-id="element-169" data-mp="1z3l0nawj43mn">
                  {tomo.desc}
                </p>
                <div className="bg-navy-800/50 p-3 rounded-lg mb-4 border border-silver/15" data-id="element-170" data-mp="242o5ovcie9um">
                  <p className="text-xs text-silver-dark mb-1" data-id="element-171" data-mp="1q3530i2gvqpp">
                    <strong className="text-silver-light" data-id="element-172" data-mp="1q4zn5u5wzesq">Resultado:</strong>
                  </p>
                  <p className="text-sm text-silver-light" data-id="element-173" data-mp="1u61m09vx5ou6">{tomo.resultado}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-174" data-mp="3ketj4nkfpzbo">
                  {tomo.tags.map(tag => <span key={tag} className="text-[10px] font-bold uppercase tracking-wider bg-navy-800 text-silver px-2 py-1 rounded border border-silver/15" data-id="element-175" data-mp="1cuw5kg3cmpor">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-silver/15 pt-16" data-id="element-176" data-mp="1wivdzkafxkr0">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-navy-800/80 text-silver-light border border-silver/30 font-bold mb-6 text-[16px]" data-id="element-177" data-mp="1wh29aaje1aln">
            🎁 LOS 4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[22px]" data-id="element-178" data-mp="20kgy9qpb11b8">
            Siempre incluidos · Siempre gratis
          </h2>
        </div>

        <div className="max-w-3xl mx-auto mb-12" data-id="element-179" data-mp="b62e7jp8e2m2">
          <p className="text-center text-xs text-silver-dark mb-2 md:hidden" data-id="element-180" data-mp="66pfa0l35534">
            ← Deslizá para ver la tabla completa →
          </p>
          <div className="overflow-x-auto" data-id="element-181" data-mp="8kciao5lmcnw">
            <table className="w-full min-w-[520px] text-left border border-silver/20 rounded-2xl overflow-hidden" data-id="element-182" data-mp="cmpn9aciu6jm">
              <thead className="bg-navy-800/80 text-silver-light" data-id="element-183" data-mp="hlao9bzlku94">
                <tr data-id="element-184" data-mp="hjpwtv8kxrfh">
                  <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider" data-id="element-185" data-mp="mknapvmk3zb6">
                    #
                  </th>
                  <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider" data-id="element-186" data-mp="3l3kettnvc4ie">
                    Bono
                  </th>
                  <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider" data-id="element-187" data-mp="3pzjam2bj0osu">
                    Valor real
                  </th>
                  <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider" data-id="element-188" data-mp="3mjfm53i80sd">
                    Tu precio
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-189" data-mp="37b4gv79tqwoc">
                {bonos.map(bono => <tr key={bono.id} className="border-t border-silver/10 bg-navy-950/60" data-id="element-190" data-mp="3799zg2xrhmp0">
                    <td className="px-4 py-3 font-bold text-silver whitespace-nowrap" data-id="element-191" data-mp="2urz7rqznlspj">
                      🎁 0{bono.id}
                    </td>
                    <td className="px-4 py-3 text-sm text-silver-light" data-id="element-192" data-mp="2prkxe2aky6oc">
                      {bono.shortTitle}
                    </td>
                    <td className="px-4 py-3 text-sm text-silver-dark line-through whitespace-nowrap" data-id="element-193" data-mp="2gshd4uzofl89">
                      {bono.valor}
                    </td>
                    <td className="px-4 py-3 text-sm font-bold text-white whitespace-nowrap" data-id="element-194" data-mp="2c0pvxb2eurus">
                      GRATIS
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="text-center text-silver font-medium mt-4 text-[14px]" data-id="element-195" data-mp="1x59weqj2a3r0">
            Valor total de los 4 bonos: $68.000 ARS · Tu precio: 🎁 GRATIS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto" data-id="element-196" data-mp="1ii1hpfqjngaa">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i % 2 * 0.1
        }} className="rounded-2xl border border-silver/20 bg-navy-950/80 p-6 flex flex-col h-full" data-id="element-197" data-mp="1nhnvpre750k5" data-mpi={i}>
              <h4 className="font-bold text-silver mb-2" data-id="element-198" data-mp="1sfz37vh0qyz7">🎁 BONO 0{bono.id}</h4>
              <h3 className="font-bold text-white text-lg mb-3" data-id="element-199" data-mp="1xe0yderpyor1">{bono.title}</h3>
              <p className="text-xs font-bold text-silver-dark mb-4 pb-3 border-b border-silver/15" data-id="element-200" data-mp="2l4mss38swaik">
                Valor real: <span className="line-through" data-id="element-201" data-mp="2pwoba6wkaxh1">{bono.valor}</span> →{' '}
                <span className="text-silver-light" data-id="element-202" data-mp="2z9wvrnrwf2e7">GRATIS</span>
              </p>
              <p className="text-silver text-sm leading-relaxed flex-grow" data-id="element-203" data-mp="2v8tfx19up6cz">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}